import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformationsource = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M316 772H684V704H555V392H357V460H477V704H316ZM490 316Q525 316 541 299Q557 282 557 255V241Q557 216 541 199Q525 182 490 182Q455 182 439 199Q423 216 423 241V255Q423 282 439 299Q455 316 490 316ZM0 498C0 830 190 1000 500 1000C810 1000 1000 830 1000 498C1000 191 810 0 500 0C190 0 0 191 0 498ZM82 558V438C82 235 260 74 500 74C740 74 918 235 918 438V558C918 771 768 926 504 926C240 926 82 771 82 558Z" })
});
export default SvgInformationsource;
